import axios from 'axios';

const API_BASE = process.env.VUE_APP_BE_APP_BASE_URL + '/api/blast-outbox';

export const workerService = {
    async getConfigs() {
        const response = await axios.get(`${API_BASE}/configs`);
        return response.data;
    },

    async createConfig(data) {
        const response = await axios.post(`${API_BASE}/configs`, data);
        return response.data;
    },

    async updateConfig(id, data) {
        const response = await axios.put(`${API_BASE}/configs/${id}`, data);
        return response.data;
    },

    async deleteConfig(id) {
        const response = await axios.delete(`${API_BASE}/configs/${id}`);
        return response.data;
    },

    async toggleConfig(id) {
        const response = await axios.post(`${API_BASE}/configs/${id}/toggle`);
        return response.data;
    },

    async getCircles() {
        const response = await axios.get(`${API_BASE}/available-circles`);
        return response.data;
    },

    async getApplications() {
        const response = await axios.get(`${API_BASE}/available-applications`);
        return response.data;
    }
};
